import React, { useContext } from 'react';

export const TimezoneContext = React.createContext(null);

export const useTimezone = () => {
	return useContext(TimezoneContext);
};
